module.exports = __webpack_public_path__ + "img/CHINAUMS_WX_MINI2.ddceb1d9.png";